import styled from 'styled-components'

export const PageContent = styled.div`
  min-height: 500px;
  width: 1200px;
  background-color: var(--color-primary);
  padding: 4rem 10rem;
  margin: 2rem auto;
  font-size: 1.1rem;
  line-height: 1.9;
  color: var(--color-reverse);

  h1 {
    margin: 0 auto;
    margin-bottom: 2rem;
  }

  p {
    max-width: 880px;
    font-size: 1.2rem;
    margin: 0 auto;
    margin-bottom: 6rem;
  }

  button {
    padding: 0.8rem 2rem;
    font-family: 'Bungee';
    font-size: 1rem;
    cursor: pointer;
    float: right;
    margin: 2rem 0;
  }

  @media only screen and (max-width: 1232px) {
    padding: 4rem;
    margin: 2rem auto;
    width: 95%;
  }

  @media only screen and (max-width: 768px) {
    padding: 2rem 2rem;
    margin: 0 auto;
    width: 100%;
  }

  @media only screen and (max-width: 425px) {
    padding: 2rem 1rem;
  }
`
